import { createContext, useState, useEffect } from "react";
import { auth } from "../firebase";
import { onAuthStateChanged, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut } from "firebase/auth";

async function registerUser(email, password) {
    try {
        // Cria o usuário no Firebase Authentication
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;

        // Envia os dados para o backend em PHP para salvar no MySQL
        const response = await fetch("https://romaneio.salexpress.com.br/roterizacao/cadastro.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email,
                password,
            }),
        });

        const data = await response.json();

        if (data.success) {
            console.log("Usuário cadastrado com sucesso no banco!");
            return { success: true, message: "Usuário cadastrado com sucesso!" };
        } else {
            console.error("Erro ao cadastrar no banco:", data.message);
            return { success: false, message: data.message || "Erro ao cadastrar no banco." };
        }
    } catch (error) {
        console.error("Erro no cadastro:", error.message);
        return { success: false, message: error.message || "Erro no cadastro." };
    }
}

export { registerUser };

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const register = async (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const login = async (email, password) => {
    // Realiza o login no Firebase
    const firebaseUser = await signInWithEmailAndPassword(auth, email, password);
    // Valida as credenciais no backend PHP
    const response = await fetch("https://romaneio.salexpress.com.br/roterizacao/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
    });
    const data = await response.json();
    if (data.success) {
        return firebaseUser;
    } else {
        await signOut(auth);
        throw new Error(data.message || "Erro ao autenticar no servidor.");
    }
  };

  const logout = async () => {
    return signOut(auth);
  };

  return (
    <AuthContext.Provider value={{ user, register, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
